<script lang="ts">
  type Type = "text" | "number" | "email" | "password" | "search" | "tel" | "url";

  interface Props {
    value?: HTMLInputElement["value"] | HTMLInputElement["valueAsNumber"] | null;
    type?: Type;
    name: string | null;
    id: string | null;
    placeholder: string | null;
    required?: boolean | null;
    pattern?: string | null;
    autocomplete?: "on" | "off" | null;
    min?: string | null;
    step?: string | null;
    class?: string;
    oninput?: (event: Event) => void;
    oninvalid?: (event: Event) => void;
  }

  let {
    value = $bindable(null),
    type = "text",
    name,
    id,
    placeholder,
    required = null,
    pattern = null,
    autocomplete = null,
    min = null,
    step = null,
    class: classes = "",
    oninput,
    oninvalid
  }: Props = $props();
</script>

<input
  {...{ type }}
  {name}
  {id}
  {placeholder}
  {required}
  {pattern}
  {autocomplete}
  {min}
  {step}
  class="text-input {classes}"
  {...{oninvalid}}
  {...{oninput}}
  bind:value
/>
